import { DEMO_TURMA_DISC } from "./buildDemoOccurrences";
import { buildDemoStudentsForClass } from "./buildDemoStudents";
import { joinOccurrenceNotes } from "../utils/occurrenceAdvanced";

/**
 * Etapas para o diálogo de ocorrência (GET ClassDiaryV1/stages).
 */
export function buildDemoOccurrenceStages(classId) {
  if (classId !== "DEMO-T1") {
    return [];
  }
  const year = new Date().getFullYear();
  return [
    {
      id: "ET1",
      name: "1º bimestre — demonstração",
      shortName: "1B",
      start: `${year}-02-02`,
      end: `${year}-04-30`
    },
    {
      id: "ET2",
      name: "2º bimestre — demonstração",
      shortName: "2B",
      start: `${year}-05-04`,
      end: `${year}-08-14`
    }
  ];
}

/**
 * Lista de ocorrências do aluno (GET ClassDiaryV1/student/:ra/occurrences).
 * Caminho offline (`src/demo`); a ficha da Alice no lab é dado real do TOTVS.
 */
export function buildDemoStudentOccurrences(
  studentId,
  codPerlet,
  codOccurrenceType,
  codOccurrenceReason
) {
  const students = buildDemoStudentsForClass("DEMO-T1");
  const s = students.find(x => String(x.ra) === String(studentId));
  if (!s) {
    return [];
  }

  const year = new Date().getFullYear();
  const perlet =
    codPerlet != null && codPerlet !== "" ? Number(codPerlet) : year;
  if (Number.isNaN(perlet) || perlet < year - 5) {
    return [];
  }

  const base = [
    {
      id: 910001,
      studentId: s.ra,
      reason: "Comportamento - Atraso",
      date: `${year}-04-10T10:15:00.000Z`,
      teacher: "Prof. Demo Waybee",
      courseName: "Português — demonstração",
      description: joinOccurrenceNotes(
        "Entrada após o sinal da aula.",
        "Combinar com a família o horário de chegada."
      ),
      icon: "access_time",
      editable: true,
      nivel: 3,
      idPerlet: perlet,
      idTurma: DEMO_TURMA_DISC,
      idType: 2,
      idGroup: 10,
      idStage: "ET1",
      occurrenceAttachment: [],
      responsibleAcknowledge: "N",
      responsibleName: null,
      category: null,
      title: "Atraso"
    },
    {
      id: 910002,
      studentId: s.ra,
      reason: "Pedagógico - Baixo rendimento",
      date: `${year}-03-22T14:30:00.000Z`,
      teacher: "Prof. Demo Waybee",
      courseName: "Português — demonstração",
      description: joinOccurrenceNotes(
        "Acompanhamento sugerido em leitura.",
        "Levar evidências para a próxima reunião de pais."
      ),
      icon: "menu_book",
      editable: true,
      nivel: 2,
      idPerlet: perlet,
      idTurma: DEMO_TURMA_DISC,
      idType: 5,
      idGroup: 20,
      idStage: "ET1",
      occurrenceAttachment: [],
      responsibleAcknowledge: "N",
      responsibleName: null,
      category: null,
      title: "Baixo rendimento"
    },
    {
      id: 910003,
      studentId: s.ra,
      reason: "Comportamento - Atraso",
      date: `${year}-05-08T08:05:00.000Z`,
      teacher: "Prof. Demo Waybee",
      courseName: "Português — demonstração",
      description: joinOccurrenceNotes(
        "Segundo atraso no mês.",
        "Se repetir, abrir conversa com a coordenação."
      ),
      icon: "access_time",
      editable: true,
      nivel: 3,
      idPerlet: perlet,
      idTurma: DEMO_TURMA_DISC,
      idType: 2,
      idGroup: 10,
      idStage: "ET2",
      occurrenceAttachment: [],
      responsibleAcknowledge: "N",
      responsibleName: null,
      category: null,
      title: "Atraso"
    },
    {
      id: 910004,
      studentId: s.ra,
      reason: "Excluído da sala - Saída da sala",
      date: `${year}-05-02T11:40:00.000Z`,
      teacher: "Prof. Demo Waybee",
      courseName: "Português — demonstração",
      description: joinOccurrenceNotes(
        "Registro de exclusão de sala.",
        "Retornou após 10 minutos; acompanhar reincidência."
      ),
      icon: "close",
      editable: true,
      nivel: 1,
      idPerlet: perlet,
      idTurma: DEMO_TURMA_DISC,
      idType: 61,
      idGroup: 6,
      idStage: "ET2",
      occurrenceAttachment: [],
      responsibleAcknowledge: "N",
      responsibleName: null,
      category: null,
      title: "Saída da sala"
    },
    {
      id: 910005,
      studentId: s.ra,
      reason: "Coordenação - Acompanhamento pedagógico",
      date: `${year}-05-16T11:00:00.000Z`,
      teacher: "Coord. Demo Waybee",
      courseName: "Português — demonstração",
      description: joinOccurrenceNotes(
        "Acompanhamento pedagógico da linguagem oral.",
        "Combinado com a professora: observar duas semanas e retomar."
      ),
      icon: "trending_up",
      editable: true,
      nivel: 3,
      idPerlet: perlet,
      idTurma: DEMO_TURMA_DISC,
      idType: 81,
      idGroup: 8,
      idStage: "ET2",
      occurrenceAttachment: [],
      responsibleAcknowledge: "N",
      responsibleName: null,
      category: null,
      title: "Acompanhamento pedagógico"
    }
  ];

  let out = [...base];

  if (codOccurrenceType != null && codOccurrenceType !== "") {
    const g = Number(codOccurrenceType);
    if (!Number.isNaN(g)) {
      out = out.filter(o => Number(o.idGroup) === g);
    }
  }

  if (codOccurrenceReason != null && codOccurrenceReason !== "") {
    const t = Number(String(codOccurrenceReason).split("-")[0]);
    if (!Number.isNaN(t)) {
      out = out.filter(o => Number(o.idType) === t);
    }
  }

  return out;
}

const DEMO_OCCURRENCE_ADVANCED_CONFIG = {
  groups: { "8": 3, "10": 3, "20": 2 },
  types: {},
  alertGroups: ["6"],
  alertTypes: [],
  form: {
    discipline: "optional",
    stage: "optional",
    lesson: "hidden",
    attachments: "optional",
    observations: "optional"
  }
};

export function buildDemoOccurrenceAdvancedConfig() {
  return DEMO_OCCURRENCE_ADVANCED_CONFIG;
}

/**
 * Histórico da turma (GET ClassDiaryV1/class/:id/occurrences/history).
 */
export function buildDemoClassOccurrenceHistory(classId, codPerlet) {
  if (classId !== "DEMO-T1") {
    return [];
  }
  const students = buildDemoStudentsForClass("DEMO-T1").slice(0, 3);
  return students.reduce((acc, student, index) => {
    const items = buildDemoStudentOccurrences(student.ra, codPerlet).map(
      item => ({
        ...item,
        id: Number(`${item.id}${index}`),
        studentName: student.name
      })
    );
    return acc.concat(items);
  }, []);
}
